import LOCALSTORAGE_KEYS from '@web/consts/LOCALSTORAGE_KEYS'
import { URL_SLUG } from './urlSlugs'
import type { OnboardingProgress } from './types'

function isOnboardingProgress (value: unknown): value is OnboardingProgress {
  if (typeof value !== 'object' || value === null) return false
  const obj = value as Record<string, unknown>
  return typeof obj.slug === 'string' && obj.slug.length > 0 &&
    typeof obj.step === 'string' && obj.step.length > 0
}

export function readOnboardingProgress (): OnboardingProgress | null {
  const raw = localStorage.getItem(LOCALSTORAGE_KEYS.ONBOARDING_PROGRESS)
  if (!raw) return null
  try {
    const parsed: unknown = JSON.parse(raw)
    if (isOnboardingProgress(parsed)) return parsed
    // Legacy migration: if step is a number, translate to default first-step slug
    if (
      typeof parsed === 'object' && parsed !== null &&
      typeof (parsed as Record<string, unknown>).slug === 'string' &&
      typeof (parsed as Record<string, unknown>).step === 'number'
    ) {
      const slug = (parsed as { slug: string }).slug
      const migrated: OnboardingProgress = { slug, step: URL_SLUG.PROFILE_UPDATE }
      writeOnboardingProgress(migrated)
      return migrated
    }
    return null
  } catch {
    return null
  }
}

export function writeOnboardingProgress (progress: OnboardingProgress): void {
  localStorage.setItem(LOCALSTORAGE_KEYS.ONBOARDING_PROGRESS, JSON.stringify(progress))
}

export function clearOnboardingProgress (): void {
  localStorage.removeItem(LOCALSTORAGE_KEYS.ONBOARDING_PROGRESS)
}

const LEGACY_MIN_STEP = 1
const LEGACY_MAX_STEP = 4
const LEGACY_SCENARIO_SLUG = 'inf_sp'

export function migrateLegacyOnboardingStep (): OnboardingProgress | null {
  const raw = localStorage.getItem(LOCALSTORAGE_KEYS.ONBOARDING_STEP_KEY)
  if (raw === null) return null

  localStorage.removeItem(LOCALSTORAGE_KEYS.ONBOARDING_STEP_KEY)
  const num = Number(raw)
  if (!Number.isInteger(num) || num < LEGACY_MIN_STEP || num > LEGACY_MAX_STEP) {
    return null
  }
  const progress: OnboardingProgress = { slug: LEGACY_SCENARIO_SLUG, step: URL_SLUG.PROFILE_UPDATE }
  writeOnboardingProgress(progress)
  return progress
}
